module.exports = __webpack_public_path__ + "img/robust.517bb5c3.png";